<template>
	<div id="ListShippingsRequestComponent" class="listShippingsRequestComponent">
		<button ref="btnExternalGetShippingsRequest" @click="getAllShippingsRequestExternalLocal(1)"
			v-show="false">Buscar External</button>
		<div>
			<nav class="navbar navbar-light bg-light" v-if="search == undefined">
				<div class="form-inline">
					<input class="form-control form-control-sm mr-sm-1" type="date" v-model="fromDateShippingsRequest"
						@change="getAllShippingsRequestLocal(1)">
					<input class="form-control form-control-sm mr-sm-1" type="date" v-model="toDateShippingsRequest"
						@change="getAllShippingsRequestLocal(1)">
					<input class="form-control form-control-sm mr-sm-1" type="search" placeholder="Buscar"
						aria-label="Buscar" v-model="searchShippingsRequest"
						v-on:keyup.enter="getAllShippingsRequestLocal(1)">
					<button class="btn btn-sm btn-outline-info my-2 my-sm-1" type="submit"
						@click="getAllShippingsRequestLocal(1)">Buscar</button>
					<div class="float-right d-none d-sm-inline separator"></div>
					<button class="btn btn-sm btn-outline-primary my-2 my-sm-1 margin-right5"
						title="Nueva Solicitud de Envío" @click="showShippingRequestComponentLocal()">
						<i class="fas fa-plus"></i>
					</button>
				</div>
				<div class="form-inline">
					<span class="mr-sm-1">Mostrar</span>
					<select class="form-control form-control-sm mr-sm-1 float-sm-right" id="qrows"
						v-model="qrowsShippingRequest" @change="getAllShippingsRequestLocal(1)">
						<option value="10">10</option>
						<option value="25">25</option>
						<option value="50">50</option>
						<option value="100">100</option>
						<option value="200">200</option>
						<option value="1000">1000</option>
					</select>
					<span class="mr-sm-1">Registros</span>
				</div>
			</nav>
			<table class="table table-sm table-hover table-12 table-striped table-hover-local">
				<thead>
					<tr>
						<th class="text-center">ID</th>
						<th>
							Enviar a
						</th>
						<th>Dirección</th>
						<th class="text-center">Transporte</th>
						<th class="text-center">Cta Cte</th>
						<th>Observación</th>
						<th class="text-center">
							<context-menu text="Estado" title="Click derecho para mas opciones" :list="listStatus"
								:multiSelect="true" :markSelection="true" defaultSelected="All" localStorage="status"
								_class="text-12" @actionSelectItem="actionSelectMenuItemStatusLocal"
								@actionBlur="actionBlurMenuListStatusLocal" ref="contextMenuStatus"
								:saveSelection="true">
							</context-menu>
						</th>
						<th class="text-center">Acción</th>
					</tr>
				</thead>
				<tbody>
					<tr v-if="searchingShippingsRequest" class="text-center">
						<td colspan="8">Buscando solicitudes de envío que coincidan con "{{ searchShippingsRequest }}"
						</td>
					</tr>
					<tr v-for="(item, index) in listShippingsRequestFilter" :key="index" class="border-info">
						<td class="text-center align-middle" :title="item.user + '\n' + item.created_at"><span
								@dblclick="viewAllItem(item)">{{ item.id }}</span></td>
						<td class="">
							<div class="text-12">
								{{ getRecipientData(item.shipping_request_recipient_data, 'SENDTO') }}
							</div>
							<div class="text-12">
								<small class="text-muted">{{ getRecipientData(item.shipping_request_recipient_data,
				'EMAIL') }}</small> |
								<small
									:class="(formatRUT(getRecipientData(item.shipping_request_recipient_data, 'NUMBER_DOCUMENT')) == 'NOT VALID') ? 'text-danger' : 'text-muted'">
									{{ formatRUT(getRecipientData(item.shipping_request_recipient_data,
				'NUMBER_DOCUMENT')) }}
								</small>
							</div>
						</td>
						<td>
							<div class="text-12">{{ getRecipientData(item.shipping_request_recipient_data, 'ADDRESS') }}
							</div>
							<div class="text-12">{{ getRecipientData(item.shipping_request_recipient_data, 'COMUNA') }}
							</div>
						</td>
						<td class="text-center align-middle">
							<span
								:class="'badge badge-' + getColorTransport(getRecipientData(item.shipping_request_recipient_data, 'TRANSPORTSID'))">
								{{ getRecipientData(item.shipping_request_recipient_data, 'TRANSPORTS') }}
							</span>
						</td>
						<td class="text-center align-middle">
							<i class="fas fa-check text-success"
								v-if="getRecipientData(item.shipping_request_recipient_data, 'PAIDSHIPPING')"></i>
							<i class="fas fa-times text-danger" v-else></i>
						</td>
						<td class="align-middle">
							<span>{{ item.commentary }}</span>
						</td>
						<td class="text-center align-middle" :class="'text-' + item.color"
							:title="(item.shipping.length == 1) ? 'Nº de envío ' + item.shipping[0].id + ' (' + item.shipping[0].freight_order + ')' : 'Sin Nº de envío'">
							<div class="custom-control custom-switch"
								v-if="item.status_id < 11 && auth.id == item.user_id && role.id != 1 && role.id != 2"
								:title="item.status">
								<input type="checkbox" class="custom-control-input" :id="'customSwitch' + item.id"
									v-model="item.consider" @click="changeStatusShippingRequest(item)">
								<label class="custom-control-label" :for="'customSwitch' + item.id"></label>
							</div>
							<div v-else>
								<div class="btn-group"
									v-if="isRoleFullAction() && item.status_id > 8 && item.status_id < 16">
									<button class="btn btn-sm dropdown-toggle" :class="'text-' + item.color"
										type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
										{{ item.status }}
									</button>
									<div class="dropdown-menu dropdown-menu-right">
										<button class="dropdown-item" type="button"
											v-for="(it, ind) in listTrackingsShippingRequest" :key="ind"
											v-if="it.status_id !== null && it.status_id != item.status_id"
											@click="addShippingRequestTrackingsShippingRequest(item.id, it.id)">{{
				it.status }}
										</button>
									</div>
								</div>
								<span v-else>
									{{ item.status }}
								</span>
								<i class="fas fa-check" v-if="item.status_id > 15"></i>
							</div>
						</td>
						<td class="text-right align-middle">
							<i class="fas fa-trash-alt text-danger margin-right5 pointer"
								@click="removeShippingsRequestLocal(item)"
								v-if="(item.status_id < 11 && (auth.id == item.user_id || isRoleFullAction()))"></i>
							<i class="fas fa-barcode margin-right5 pointer text-info" @click="toPrintLabelLocal(item)"
								v-show="successFullConnectionWebSocketServer"></i>
							<i class="fas fa-print margin-right5"
								:class="(!getLegalDocumentNumberRel(item)) ? 'text-muted' : 'text-info'"
								@click="toPrintLegalDocumentLocal(item)"
								:title="(getLegalDocumentNumberRel(item)) ? getLegalDocumentNumberRel(item) : 'Sin documento Adjunto'"></i>
							<i class="fas fa-info-circle text-warning pointer margin-right5"
								@click="showShippingRequestComponentLocal(item)"></i>
						</td>
					</tr>
				</tbody>
			</table>
			<pagination :pagination="paginationListShippingsRequest" @getAllList="getAllShippingsRequestLocal">
			</pagination>
		</div>

		<!-- Button trigger modal -->
		<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modalShippingRequestComponent"
			ref="btnShowModalShippingRequestComponent" v-show="false">
			Abrir ShippingRequestComponent
		</button>

		<!-- Modal -->
		<div class="modal fade" id="modalShippingRequestComponent" tabindex="-1"
			aria-labelledby="modalShippingRequestComponentLabel" aria-hidden="true">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-body">
						<button type="button" class="close" data-dismiss="modal" aria-label="Close"
							ref="btnCloseModalShippingRequestComponent">
							<span aria-hidden="true">&times;</span>
						</button>
						<shipping-request-component ref="shippingRequestComponent" :id="shippingRequestIDSelected"
							:modifyShippingRequest="modifyShippingRequestLocal"
							@actionSaveShippingRequest="actionSaveShippingRequestLocal">
						</shipping-request-component>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import shippingsRequest from '@/mixins/shippingsRequest'
import genesys from '@/mixins/genesys'
import facturacionCLPrint from '@/mixins/facturacionCLPrint.js'
import webSocketServer from '@/mixins/webSocketServer.js'
import transport from '@/mixins/transports'
import trackingShippingRequest from '@/mixins/shippingsRequest/trackingShippingRequest.js'
import status from '@/mixins/status'
import label from "@/mixins/labels/"

import ContextMenu from '@/components/ContextMenu.vue'
import Pagination from '@/components/Pagination.vue'
import ShippingRequestComponent from '@/components/ShippingRequestComponent.vue'

export default {
	name: 'listShippingsRequestComponent',
	mixins: [axiosAction, errors, mixin, shippingsRequest, genesys, facturacionCLPrint, webSocketServer, transport, trackingShippingRequest, status, label],
	props: ['search'],
	data() {
		return {
			shippingRequestIDSelected: 0,
			modifyShippingRequestLocal: false
		}
	},
	components: {
		'context-menu': ContextMenu,
		'pagination': Pagination,
		'shipping-request-component': ShippingRequestComponent,
	},
	computed: {
		listShippingsRequestFilter() {
			let list = this.listShippingsRequest
			return list
		},
	},
	methods: {
		actionSaveShippingRequestLocal(data) {
			if (data.message == 'CREADO') {
				this.addListShippingsRequest(data)
			} else if (data.message == 'ACTUALIZADO') {
				this.updateItemListShippingsRequest(data)
			}
			this.$refs.btnCloseModalShippingRequestComponent.click()
		},
		actionSelectMenuItemShippingsRequestStatusLocal(data) {
			console.log(data)
		},
		actionSelectMenuItemStatusLocal(data) {
		},
		actionBlurMenuListStatusLocal(data) {
			this.getAllShippingsRequestLocal(1)
		},
		changeStatusShippingRequest(item) {
			let trackingsShippingRequestId = (!item.consider) ? 3 : 2
			this.addShippingRequestTrackingsShippingRequest(item.id, trackingsShippingRequestId)
		},

		initComponentLocal() {
			this.fromDateShippingsRequest = this.currentDate(-3)
			this.toDateShippingsRequest = this.currentDate()
			this.getAllTransportsLocal()
			this.getAllStatusLocal()
			this.showLabelLocal()
			this.getAllTrackingsShippingRequest()
			this.rolesFullAction.push(2, 3)
		},
		getAllStatusLocal() {
			this.typeStatusId = 3
			this.getAllStatus()
		},
		getAllStatusResultLocal(response) {
			if (response.data.success == true) {
				setTimeout(() => { this.$refs.contextMenuStatus.$refs.btnEjecute.click() }, 300)
			} else {
				alert('Algo no salió bien al recuperar los estados')
			}
		},
		getAllTransportsLocal() {
			this.getAllTransports()
		},
		getAllTransportsResultLocal(response) { },
		getAllTrackingsShippingRequestResultLocal(response) { },
		getAllShippingsRequestLocal(page = 1) {
			let nameLocalStorage = 'ListShippingsRequestComponent-status'
			let statusIds = (localStorage.getItem(nameLocalStorage) != null && localStorage.getItem(nameLocalStorage) != undefined && localStorage.getItem(nameLocalStorage) != 'null' && localStorage.getItem(nameLocalStorage) != 'undefined') ? JSON.parse(localStorage.getItem(nameLocalStorage)) : []
			this.getAllShippingsRequest(page, statusIds)
		},
		getAllShippingsRequestExternalLocal(page = 1) {
			this.searchShippingsRequest = this.search
			this.getAllShippingsRequestLocal(page)
		},
		getAllShippingsRequestResultLocal(response) {
			if (this.listShippingsRequestFilter.length > 0) {
				setTimeout(() => {
					this.listShippingsRequestFilter.forEach(e => {
						//this.$refs['contextMenuStatusItemShippingsRequest' + e.id][0].$refs.btnEjecute.click()
					})
				}, 500)
			}
		},
		removeShippingsRequestLocal(item) {
			if (confirm('Esta a punto de borrar la solucitud de envío "' + item.id + ' (' + item.commentary + ')".\n¿Quiere continuar? ')) {
				this.deleteShippingRequest(item.id)
			}
		},
		resultAxiosLocal(responseLocal, response) {
			switch (responseLocal) {
				case 'getAllTransportsResult': this.getAllTransportsResult(response); break;
				case 'getAllStatusResult': this.getAllStatusResult(response); break;
				case 'getAllTrackingsShippingRequestResult': this.getAllTrackingsShippingRequestResult(response); break;
				case 'resultAddShippingRequestTrackingsShippingRequestPOST': this.resultAddShippingRequestTrackingsShippingRequest(response); break;
				case 'resultDeleteShippingRequest': this.resultDeleteShippingRequest(response); break;
				case 'resultGetAllShippingsRequest': this.resultGetAllShippingsRequest(response); break;
				case 'resultShowLabelGET': this.resultShowLabelGET(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
		resultDeleteShippingRequestLocal(response) { },
		showLabelLocal() {
			this.showLabel(1)
		},
		showLabelResultLocal(response) { },
		showShippingRequestComponentLocal(item = null) {
			this.shippingRequestIDSelected = (item != null) ? item.id : 0
			this.modifyShippingRequestLocal = (this.shippingRequestIDSelected == 0) ? true : false
			this.modifyShippingRequestLocal = (!this.modifyShippingRequestLocal && (item.status_id < 11 && this.auth.id == item.user_id)) ? true : this.modifyShippingRequestLocal
			this.$refs.btnShowModalShippingRequestComponent.click()
			setTimeout(() => { this.$refs.shippingRequestComponent.$refs.btnGetShippingRequest.click() }, 200)
		},
		toPrintLegalDocumentLocal(item) {
			item.shipping_request_genesys_cabmov.forEach(e => {
				if (parseInt(e.tipocompcod) == 1 || parseInt(e.tipocompcod) == 33 || parseInt(e.tipocompcod) == 39 || parseInt(e.tipocompcod) == 52 || parseInt(e.tipocompcod) == 56 || parseInt(e.tipocompcod) == 61) {
					e.tipocompcod = (parseInt(e.tipocompcod) == 1) ? 39 : (parseInt(e.tipocompcod) == 2) ? 61 : parseInt(e.tipocompcod)
					this.toPrintFacturacionCL(e.tipocompcod, e.nrocomp)
				}
			})
			item.legal_documents.forEach(e => {
				console.log('Imprimir', e.type_legal_document_id, e.legal_document_number)
				this.toPrintFacturacionCL(e.type_legal_document_id, e.legal_document_number)
			})
		},
		toPrintLabelLocal(item) {
			let index = this.listTransports.map((el) => parseInt(el.id)).indexOf(parseInt(this.getRecipientData(item.shipping_request_recipient_data, 'TRANSPORTSID')))
			let arrayZPL = []
			let user = item.user.split(' ')
			let initials = ''
			user.forEach(e => {
				if (e.length > 0) {
					initials += e.substring(0, 1).toUpperCase()
				}
			})

			if (item.shipping_request_recipient_data.length == 1) {
				arrayZPL.push({ 'name': 'sendto', 'value': this.cleanedStringZPL(this.getRecipientData(item.shipping_request_recipient_data, 'SENDTO')).toUpperCase() })
				arrayZPL.push({ 'name': 'address', 'value': this.cleanedStringZPL(this.getRecipientData(item.shipping_request_recipient_data, 'ADDRESS')).toUpperCase() })
				arrayZPL.push({ 'name': 'comuna', 'value': this.cleanedStringZPL(this.getRecipientData(item.shipping_request_recipient_data, 'COMUNA')).toUpperCase() })
				arrayZPL.push({ 'name': 'phone', 'value': this.getRecipientData(item.shipping_request_recipient_data, 'PHONE').toUpperCase() })
				arrayZPL.push({ 'name': 'number_document', 'value': this.formatRUT(this.getRecipientData(item.shipping_request_recipient_data, 'NUMBER_DOCUMENT')) })
				arrayZPL.push({ 'name': 'email', 'value': this.getRecipientData(item.shipping_request_recipient_data, 'EMAIL') })
				arrayZPL.push({ 'name': 'initials', 'value': initials.toUpperCase() })
				arrayZPL.push({ 'name': 'img_zpl', 'value': (this.listTransports[index].img_zpl == null || this.listTransports[index].img_zpl == '') ? this.listTransports[index].name : this.listTransports[index].img_zpl })
				arrayZPL.push({ 'name': 'paid_shipping_desc', 'value': (item.shipping_request_recipient_data[0].paid_shipping == 0) ? 'POR PAGAR' : '' })
			}
			arrayZPL.push({ 'name': 'nrocomp', 'value': this.getNrocompGenesys(item.shipping_request_genesys_cabmov, 'INT') })
			arrayZPL.push({ 'name': 'codbareti', 'value': this.getCodbaretiGenesys(item.shipping_request_genesys_cabmov) })
			arrayZPL.push({ 'name': 'codbareti2', 'value': item.barcode + '0001' })
			arrayZPL.push({ 'name': 'nrocompLegal', 'value': this.getLegalDocumentNumberRel(item, 'MAIN') })
			arrayZPL.push({ 'name': 'total_price', 'value': item.total_price })
			this.replaceZPLVariableFromArray(arrayZPL)
			this.toPrintWithVariables()
		},
	},
	mounted() {
		this.initComponentLocal()
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
